import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { CheckboxWithLabel } from '@myn/mui'; // TODO: Replace with tw-pattern when available

import AcceptedPlatforms from '../../AcceptedPlatform/AcceptedPlatforms.jsx';

type Props = {
  isChecked: boolean;
  onChangeCheck: () => void;
};

const FirstStep = ({ isChecked, onChangeCheck }: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <div className="flex flex-col">
      <AcceptedPlatforms />
      <p
        className={cn(
          typographyVariants({
            variant: 'h4',
          }),
          'mt-4',
        )}
      >
        {t('If you proceed this suggestion will be accepted')}
      </p>
      <div className="mt-2 flex flex-row">
        <CheckboxWithLabel
          checked={isChecked}
          onChange={onChangeCheck}
          label={t('Yes, I am sure.')}
        />
      </div>
    </div>
  );
};

export default FirstStep;
